import { appFeature } from 'modules/organizer/domain/interfaces/available-feature';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeature } from 'shared/hooks/use-feature';

type FeatureRouteProps = {
  children: JSX.Element;
  /**
   * Фича тарифа, без которой раздел закрыт. Без неё — вкладка «Подписка» с этой фичей: там уже
   * выбран самый дешёвый тариф, где она есть, а пункт меню с той же `feature` ведёт туда же.
   */
  feature: appFeature;
  /** Куда увести вместо тарифа — когда раздел без фичи ведёт не на покупку (табло OBS → список табло). */
  fallback?: string;
};

const FeatureRoute = React.memo((props: FeatureRouteProps) => {
  const { children, feature, fallback } = props;
  const { isEnabled, isFetching } = useFeature(feature);

  if (isFetching) return null;
  if (!isEnabled) {
    // `replace`: «Назад» с вкладки тарифа не должен возвращать на закрытый адрес и снова сюда.
    return <Navigate to={fallback ?? Pages.SETTINGS.builders.subscription(feature)} replace />;
  }
  return children;
});

export default FeatureRoute;
